import connectionManager from '../connectionManager/epics';
import runEpics from './runEpics';
import thunkRejected from './thunkRejected';

export { default as epicMiddleware } from './epicMiddleware';

export const startEpicMiddleware = () => runEpics(connectionManager, thunkRejected);
